<template>
  <el-dialog title="选择主要数据" :visible.sync="visible" :close-on-click-modal="false" :modal="false">
    <el-radio-group v-model="first">
      <el-radio
        v-for="radish in radishes"
        :key="radish._id"
        :label="radish._id"
        class="block mb5"
        style="margin-left:0;"
      >
        <span class="dialog-span drawer-link" @click="showRadish(radish._id)">{{ radish.姓名 }}</span>
        <span class="dialog-span" style="color:#aaa">{{ radish.手机 }}</span>
        <span class="dialog-span">{{ radish.公司 }}</span> <span class="dialog-span">{{ radish.部门 }}</span>
        <span class="dialog-span">{{ radish.目前职位 }}</span> <span class="dialog-span">{{ radish.职级 }}</span>
        <span class="dialog-span">
          <el-tag v-for="tag in radish.职能模块 || []" :key="tag" size="mini">{{ tag }}</el-tag>
        </span>
      </el-radio>
    </el-radio-group>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="$emit('update:visible', false)">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    radishes: { type: Array, default: () => [] },
    mergeSuccess: { type: Function, default: () => [] },
  },
  data() {
    return {
      first: '',
    }
  },
  computed: {
    radishDetailTab() {
      return app.root.$refs.radishDetailTab
    },
  },
  methods: {
    showRadish(id) {
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
    async confirm() {
      if (this.first === '') return this.$message('请选择以哪条数据为主')
      const { first, radishes } = this
      const second = radishes.map(v => v._id).filter(v => v !== first)
      const { status, msg } = await app.service('radish').mergeMult({ id: first, first, second })
      if (status === 'success') {
        this.mergeSuccess && this.mergeSuccess(first, second)
        this.$emit('update:visible', false)
        this.$message({ type: 'success', message: '合并成功' })
      } else {
        this.$message.error(msg)
      }
    },
  },
}
</script>

<style></style>
